import { render, staticRenderFns } from "./SignUp2.vue?vue&type=template&id=4764a77c&"
import script from "./SignUp2.vue?vue&type=script&lang=ts&"
export * from "./SignUp2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports